import React, { useEffect } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import SbEditable from 'storyblok-react';

import { navItemsWithPowerProItems } from '../../utils/getPowerProFields';
import { metrics } from '../../services';
import { ReactComponent as Logo } from './logo.svg';
import LinkWrap from '../link_wrap';
import './navi.scss';
import FlyoutMenu from './flyout_menu.js';

const GlobalNavi = (props) => {
  useEffect(() => {
    require('../../scripts/header-scroller.js');
  }, []);

  const logCall = () => {
    // Metrics gathering always best-effort. Never disrupt user flow.
    try {
      metrics.trackNavigationPhoneClick();
    } catch {}

    return true;
  };

  let naviItems = [];

  // If the user is editing the navigation items in Storyblok from the "global-navi" item,
  // use that as the source for items. Otherwise, pull it from the StaticQuery

  if (props.blok.nav_items) {
    naviItems = props.blok.nav_items;
  } else if (
    props.data &&
    props.data.stories &&
    props.data.stories.edges &&
    props.data.stories.edges[0].node
  ) {
    naviItems = JSON.parse(props.data.stories.edges[0].node.content).nav_items;
  }

  const navClasses = ['navbar', 'fixed-top', 'navbar-never-expand', 'scroll-container'];

  const logoClasses = ['logo-image'];
  logoClasses.push('theme-' + props.blok.theme);

  let phoneFormatted = '(999) 999-9999';

  if (props.blok.phone_number) {
    phoneFormatted = props.blok.phone_number.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/g, '($2) $3-$4');
  }

  if (props.blok.buffer_top) {
    navClasses.push('buffer-top');
  }

  return (
    <SbEditable content={props.blok}>
      <nav className={navClasses.join(' ')}>
        <span className="navbar-brand">
          <LinkWrap to="/" aria-label="Swell Energy Home">
            <Logo className={logoClasses.join(' ')} />
          </LinkWrap>
        </span>
        <div className="cta-menu">
          {!props.blok.hide_phone && (
            <span className="cta-phone">
              <a
                className={'theme-' + props.blok.theme}
                href={'tel:' + props.blok.phone_number}
                onClick={logCall}
              >
                {phoneFormatted}
              </a>
            </span>
          )}
          {!props.blok.hide_menu && (
            <FlyoutMenu
              theme={props.blok.theme}
              navItems={navItemsWithPowerProItems({
                navItems: naviItems,
                ...props.powerProData,
              })}
            ></FlyoutMenu>
          )}
        </div>
      </nav>
    </SbEditable>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        stories: allStoryblokEntry(filter: { slug: { eq: "global-navi" } }) {
          edges {
            node {
              id
              name
              created_at
              uuid
              slug
              field_component
              full_slug
              content
              is_startpage
              parent_id
              group_id
            }
          }
        }
      }
    `}
    render={(data) => <GlobalNavi data={data} {...props} />}
  />
);
